<template>
	<containers-collapsible
    doubleColumn
	:title="t('cards.consult.cardDetails.title')"
	:class="{'mobile': getMobileAppState}"
	:startClosed="getMobileAppState">
		<infobox-generic :class="{'ajust-margin': getMobileAppState}" :label="selectedCard.notes"/>
		<!-- Card Type -->
		<text-blocks-generic :params="cardTypeParams"/>
		<!-- Card Name -->
		<text-blocks-generic :params="cardNameParams"/>
	</containers-collapsible>
</template>

<script setup>
import ContainersCollapsible from '@/components/generic/containers/Collapsible'
import TextBlocksGeneric from '@/components/generic/textBlocks/Generic'
import InfoboxGeneric from '@/components/generic/infobox/Generic'

/* Assets & Helpers */
import { computed } from 'vue'
/* Store */
import { mapGetters } from '@/store/helpers/mappers'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const { getMobileAppState } = mapGetters()

/* Props received:
@selectedCard { Object }
*/
const props = defineProps({
    selectedCard: Object
})

const cardTypeParams = computed(() => {
	return {
		label: t('cards.consult.cardDetails.cardTypeLabel'),
		content: props.selectedCard.cardTypeDescription ? props.selectedCard.cardTypeDescription : props.selectedCard.type
	}
})
const cardNameParams = computed(() => {
	return {
		label: t('cards.consult.cardDetails.ownerLabel'),
		content: props.selectedCard.name
	}
})

</script>

<style lang="scss" scoped>
</style>
